"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeliveryOptionsDialogContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _models = require("../../models");
var _Skeleton = require("../Skeleton");
var _Suggestions = require("../Suggestions/Suggestions");
var _useDeliverySuggestions = require("../Suggestions/useDeliverySuggestions");
var _shared = require("../shared");
var _EmptyAddresses = require("./EmptyAddresses");
var _EmptyHistory = require("./EmptyHistory");
var _NewDelivery = require("./NewDelivery");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const DeliveryOptionsDialogContent = ({
  historyToggleProps,
  isAddHomeDeliveryAddressAllowed,
  isDeliveryOptionsLoaded,
  isPickUpAvailable,
  newDeliveryProps,
  ...props
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    isDisplayingAddresses
  } = props;
  const {
    deliveryFilterProps,
    isActiveFilter,
    isHistoryEmpty,
    suggestionsProps
  } = (0, _useDeliverySuggestions.useDeliverySuggestions)(props);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContentRoot, {
    ...getTestIdProps(_models.TestId.DeliveryOptionsModalContent),
    children: isDeliveryOptionsLoaded ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [isAddHomeDeliveryAddressAllowed || isPickUpAvailable ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_NewDelivery.NewDelivery, {
        ...newDeliveryProps
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ToggleWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.HistoryToggle, {
          ...historyToggleProps
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.YourDeliveryOptionsHeader, {
        ...getTestIdProps(_models.TestId.DeliveryOptionsHeader),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_shared.FilterButton, {
          ...deliveryFilterProps
        })
      }), isActiveFilter ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Suggestions.Suggestions, {
        ...suggestionsProps
      }) : null, !isActiveFilter && !isDisplayingAddresses || isHistoryEmpty ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyHistory.EmptyHistory, {}) : null, !isActiveFilter && isDisplayingAddresses ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyAddresses.EmptyAddresses, {}) : null]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_Skeleton.DeliveryOptionsSkeleton, {})
  });
};
exports.DeliveryOptionsDialogContent = DeliveryOptionsDialogContent;